import { c as _c } from "react/compiler-runtime";
import { CUSTOM_DOMAINS_SETTINGS_API } from 'modules/profile/custom-domains-settings/api/custom-domain-api';
import { CustomDomainsLoginPageApiInterface } from 'modules/profile/custom-domains-settings/types/custom-domains-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useCustomDomainPageApi = domainId => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== domainId || $[2] !== postFetcher) {
    t1 = () => postFetcher(`${CUSTOM_DOMAINS_SETTINGS_API}/login-page-url/${domainId}`);
    $[1] = domainId;
    $[2] = postFetcher;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getLoginPageUrl = t1;
  let t2;
  if ($[4] !== domainId || $[5] !== postFetcher) {
    t2 = () => postFetcher(`${CUSTOM_DOMAINS_SETTINGS_API}/not-found-page-url/${domainId}`);
    $[4] = domainId;
    $[5] = postFetcher;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const get404PageUrl = t2;
  let t3;
  if ($[7] !== get404PageUrl || $[8] !== getLoginPageUrl) {
    t3 = {
      getLoginPageUrl,
      get404PageUrl
    };
    $[7] = get404PageUrl;
    $[8] = getLoginPageUrl;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};